import { action, makeObservable, observable } from "mobx";

export class LoginDetail {
  @observable
  username: string = '';

  @observable
  password: string = '';

  @observable
  newPassword: string = '';

  @observable
  confirmedPassword: string = '';

  @observable
  forgotPasswordCode: string = '';

  constructor() {
    makeObservable(this);
  }

  static emptyInstance() {
    return new LoginDetail();
  }

  @action
  setUsername(username: string) {
    this.username = username;
  }

  @action
  setPassword(password: string) {
    this.password = password;
  }

  @action
  setNewPassword(password: string) {
    this.newPassword = password;
  }

  @action
  setConfirmedPassword(password: string) {
    this.confirmedPassword = password;
  }

  @action
  setForgotPasswordCode(code: string) {
    this.forgotPasswordCode = code;
  }

  isUsernameComplete() {
    return this.username.includes('@');
  }

  isForgotPasswordCodeComplete() {
    return this.forgotPasswordCode.length >= 6;
  }
}